import { Star } from 'lucide-react';

/**
 * A star row rendered as real icons.
 *
 * These were "★★★★★" typed as text, which renders as a different glyph on every
 * OS, can't be sized or coloured consistently, and inherits letter-spacing hacks
 * to look even. Five lucide stars instead — per the no-glyph-icons rule.
 */
export default function Stars({ count = 5, size = 14, color = '#E6B400' }: { count?: number; size?: number; color?: string }) {
  return (
    <span style={{ display: 'inline-flex', gap: 2, verticalAlign: 'middle' }} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <Star key={i} size={size} fill={color} color={color} strokeWidth={0} />
      ))}
    </span>
  );
}
